/**
 *
 * media-config constants
 *
 */

export const CONFIG_KEY = 'mediaConfig';

export const SET_USER_LOCATION = `mlb/${CONFIG_KEY}/SET_USER_LOCATION`;
